export default {
  "1": require("./assets/avatars/ajolote.png").default,
  "2": require("./assets/avatars/anaconda.png").default,
  "3": require("./assets/avatars/arctic-fox.png").default,
  "4": require("./assets/avatars/bat.png").default,
  "5": require("./assets/avatars/bear.png").default,
  "6": require("./assets/avatars/beaver.png").default,
  "7": require("./assets/avatars/bee2.png").default,
  "8": require("./assets/avatars/bee.png").default,
  "9": require("./assets/avatars/bird.png").default,
  "10": require("./assets/avatars/boar.png").default,
  "11": require("./assets/avatars/buffalo2.png").default,
  "12": require("./assets/avatars/buffalo.png").default,
  "13": require("./assets/avatars/butterfly.png").default,
  "14": require("./assets/avatars/cat.png").default,
  "15": require("./assets/avatars/chameleons.png").default,
  "16": require("./assets/avatars/chick.png").default,
  "17": require("./assets/avatars/chicken.png").default,
  "18": require("./assets/avatars/clownfish.png").default,
  "19": require("./assets/avatars/cow.png").default,
  "20": require("./assets/avatars/cow2.png").default,
  "21": require("./assets/avatars/crab.png").default,
  "22": require("./assets/avatars/crocodile.png").default,
  "23": require("./assets/avatars/deer2.png").default,
  "24": require("./assets/avatars/deer.png").default,
  "25": require("./assets/avatars/dinosaur.png").default,
  "26": require("./assets/avatars/dog.png").default,
  "27": require("./assets/avatars/dog2.png").default,
  "28": require("./assets/avatars/dolphin2.png").default,
  "29": require("./assets/avatars/dolphin.png").default,
  "30": require("./assets/avatars/donkey.png").default,
  "31": require("./assets/avatars/dragon2.png").default,
  "32": require("./assets/avatars/dragon.png").default,
  "33": require("./assets/avatars/dragonfly.png").default,
  "34": require("./assets/avatars/duck.png").default,
  "35": require("./assets/avatars/eagle.png").default,
  "36": require("./assets/avatars/elephant2.png").default,
  "37": require("./assets/avatars/elephant.png").default,
  "38": require("./assets/avatars/ferret.png").default,
  "39": require("./assets/avatars/fish.png").default,
  "40": require("./assets/avatars/frog2.png").default,
  "41": require("./assets/avatars/frog.png").default,
  "42": require("./assets/avatars/giraffe2.png").default,
  "43": require("./assets/avatars/giraffe.png").default,
  "44": require("./assets/avatars/goat.png").default,
  "45": require("./assets/avatars/gorilla2.png").default,
  "46": require("./assets/avatars/gorilla.png").default,
  "47": require("./assets/avatars/grizzly.png").default,
  "48": require("./assets/avatars/hedgehog.png").default,
  "49": require("./assets/avatars/hen.png").default,
  "50": require("./assets/avatars/heron.png").default,
  "51": require("./assets/avatars/hippo.png").default,
  "52": require("./assets/avatars/horse.png").default,
  "53": require("./assets/avatars/hyena.png").default,
  "54": require("./assets/avatars/jaguar2.png").default,
  "55": require("./assets/avatars/jaguar.png").default,
  "56": require("./assets/avatars/jellyfish.png").default,
  "57": require("./assets/avatars/kangaroo.png").default,
  "58": require("./assets/avatars/killer-whale.png").default,
  "59": require("./assets/avatars/kitten.png").default,
  "60": require("./assets/avatars/kiwi.png").default,
  "61": require("./assets/avatars/koala2.png").default,
  "62": require("./assets/avatars/koala.png").default,
  "63": require("./assets/avatars/ladybug.png").default,
  "64": require("./assets/avatars/lamb.png").default,
  "65": require("./assets/avatars/lion.png").default,
  "66": require("./assets/avatars/llama.png").default,
  "67": require("./assets/avatars/monkey.png").default,
  "68": require("./assets/avatars/moose.png").default,
  "69": require("./assets/avatars/mouse.png").default,
  "70": require("./assets/avatars/octopus.png").default,
  "71": require("./assets/avatars/ostrich.png").default,
  "72": require("./assets/avatars/owl2.png").default,
  "73": require("./assets/avatars/owl.png").default,
  "74": require("./assets/avatars/panda.png").default,
  "75": require("./assets/avatars/penguin2.png").default,
  "76": require("./assets/avatars/penguin.png").default,
  "77": require("./assets/avatars/pig.png").default,
  "78": require("./assets/avatars/platypus.png").default,
  "79": require("./assets/avatars/polar-bear.png").default,
  "80": require("./assets/avatars/puffer-fish2.png").default,
  "81": require("./assets/avatars/puffer-fish.png").default,
  "82": require("./assets/avatars/puffin.png").default,
  "83": require("./assets/avatars/rabbit2.png").default,
  "84": require("./assets/avatars/rabbit.png").default,
  "85": require("./assets/avatars/rat.png").default,
  "86": require("./assets/avatars/rhinoceros.png").default,
  "87": require("./assets/avatars/scorpion.png").default,
  "88": require("./assets/avatars/sea-lion.png").default,
  "89": require("./assets/avatars/shark2.png").default,
  "90": require("./assets/avatars/shark.png").default,
  "91": require("./assets/avatars/skunk.png").default,
  "92": require("./assets/avatars/sloth.png").default,
  "93": require("./assets/avatars/snail.png").default,
  "94": require("./assets/avatars/snake2.png").default,
  "95": require("./assets/avatars/snake.png").default,
  "96": require("./assets/avatars/snowy-owl.png").default,
  "97": require("./assets/avatars/spider.png").default,
  "98": require("./assets/avatars/stingray.png").default,
  "99": require("./assets/avatars/swan.png").default,
  "100": require("./assets/avatars/tiger2.png").default,
  "101": require("./assets/avatars/tiger3.png").default,
  "102": require("./assets/avatars/tiger.png").default,
  "103": require("./assets/avatars/tortoise.png").default,
  "104": require("./assets/avatars/turtle.png").default,
  "105": require("./assets/avatars/walrus2.png").default,
  "106": require("./assets/avatars/walrus.png").default,
  "107": require("./assets/avatars/whale2.png").default,
  "108": require("./assets/avatars/whale3.png").default,
  "109": require("./assets/avatars/whale.png").default,
  "110": require("./assets/avatars/wild-boar.png").default,
  "111": require("./assets/avatars/wolf2.png").default,
  "112": require("./assets/avatars/wolf.png").default,
  "113": require("./assets/avatars/worm.png").default,
  "114": require("./assets/avatars/zebra.png").default,
};
